import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Evitar que la rueda del mouse cambie el valor en inputs type="number"
document.addEventListener('wheel', (e) => {
  const el = e.target;
  if (el && el.type === 'number') {
    e.preventDefault();
  }
}, { passive: false });

// Evitar que las flechas arriba/abajo modifiquen el valor en inputs type="number"
document.addEventListener('keydown', (e) => {
  const el = e.target;
  if (el && el.type === 'number' && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
    e.preventDefault();
  }
});

root.render(<App />);